// extracted by mini-css-extract-plugin
export default {"container":"legend_container__inIjL","pl6":"legend_pl6__e+vxN"};